import { isNativeFunction } from "./js-polyfills.js";
let freshGlobals = null;
/**
 * Returns unmodified globals from a fresh realm, created on first use.
 *
 * @returns Globals from a fresh realm
 */
function getFreshGlobals() {
    if (freshGlobals === null) {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        document.documentElement.append(iframe);
        const freshWindow = iframe.contentWindow;
        freshGlobals = {
            Map: freshWindow.Map,
        };
        iframe.remove();
    }
    return freshGlobals;
}
/**
 * Returns the given global from the current global scope if it's unmodified,
 * otherwise from a fresh realm.
 *
 * @param name Name of the global to retrieve
 * @param isPristine Whether the given value of the global is unmodified
 * @returns An unmodified value of the global
 */
function pristineGlobal(name, isPristine) {
    const value = globalThis[name];
    if ((value !== undefined && value !== null && isPristine(value)) ||
        // Without a document (e.g. in a worker), there's no fresh realm to use.
        typeof document === "undefined") {
        return value;
    }
    return getFreshGlobals()[name];
}
const PristineMap = pristineGlobal("Map", (map) => isNativeFunction(map) &&
    ["get", "set", "has", "delete", "clear", "forEach"].every((method) => typeof map.prototype[method] === "function" &&
        isNativeFunction(map.prototype[method])));
export { PristineMap as Map };
